module.exports = __webpack_public_path__ + "static/media/about-section.4e8b52de.svg";